import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideRouter } from '@angular/router';
import { tokenInterceptor } from './_helpers/token.interceptor';
import { routes } from './app.routes';
import { provideClientHydration } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DatePipe } from '@angular/common';

export const appConfig: ApplicationConfig = {  
  providers: [
    provideRouter(routes),
    provideClientHydration(),
    provideAnimations(),     
    provideHttpClient(withInterceptors(
      [tokenInterceptor]
    )),
    importProvidersFrom([BrowserAnimationsModule]),
    DatePipe
   ]
};
